import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { SectionRuleHeader } from '../components/SectionRuleHeader';
import { StopAllButton } from '../components/StopAllButton';
import { LiveFeed } from './LiveFeed';
import type { FeedEntry } from './feed';
import type { NeedsYouItem } from './needsYou';

/** The rail's contents, shown inside the Live drawer (which is the complementary landmark). */
export function HubRail({
  needsYou, feed, stoppable, start,
}: {
  needsYou: NeedsYouItem[];
  /** Small real-time lines, newest first. */
  feed: FeedEntry[];
  /** Working (started) runs only — what stop-all can kill; 0 hides the control. */
  stoppable: number;
  /** Start actions. */
  start: ReactNode;
}) {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-5">
      {needsYou.length > 0 && (
        <section className="shrink-0">
          <SectionRuleHeader label="Needs you" tone="signal" right={needsYou.length} />
          <ul className="space-y-1.5">
            {needsYou.map((item) => (
              <li key={item.key}>
                <Link to={item.href}
                  className="block rounded-control border border-signal bg-signal-soft px-2.5 py-1.5 text-xs text-ink hover:border-ink">
                  <span className="font-mono">{item.projectLabel}</span> · {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}
      <section className="flex min-h-0 flex-1 flex-col">
        <SectionRuleHeader label="Live feed" right={stoppable > 0 ? <StopAllButton stoppable={stoppable} /> : undefined} />
        {/* The drawer bounds the rail at every size; the feed flexes to fill what is left. */}
        <div className="min-h-0 flex-1 overflow-y-auto">
          <LiveFeed entries={feed} />
        </div>
      </section>
      <section className="shrink-0">
        <SectionRuleHeader label="Start" />
        {start}
      </section>
    </div>
  );
}
